/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { getInitials } from 'uplisting-frontend/utils/get-initials';

export type AvatarSize = 'xs' | 'sm' | 'md';

interface IArgs {
  name?: string | null;
  size?: AvatarSize;
  title?: string;
}

interface AvatarSignature {
  Element: HTMLSpanElement;

  Args: IArgs;
}

export default class UiAvatarComponent extends Component<AvatarSignature> {
  @cached
  get initials(): string {
    return getInitials(this.args.name ?? undefined) || '?';
  }

  @cached
  get isEmpty(): boolean {
    return this.initials === '?';
  }

  @cached
  get size(): AvatarSize {
    return this.args.size ?? 'sm';
  }

  @cached
  get title(): string | undefined {
    return this.args.title ?? this.args.name ?? undefined;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Avatar': typeof UiAvatarComponent;
  }
}
